import { useContextOrThrow } from '../../../../lib/use-context-or-throw';
import { nameof } from '../../../../lib/name-of';
import { PartitionNavigationContext } from './PartitionNavigationContext';

export const usePartitionNavigation = () =>
  useContextOrThrow(
    PartitionNavigationContext,
    nameof({ CalendarContext: PartitionNavigationContext })
  );
